export default __webpack_public_path__ + "static/media/crossIconRed.6d46320d.svg";